import { render, staticRenderFns } from "./NavbarUser.vue?vue&type=template&id=3a00f548"
import script from "./NavbarUser.vue?vue&type=script&lang=js"
export * from "./NavbarUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports